import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import { css } from "styled-components";

cardContainerMultiColumnStyles.cardDivider = mergeToNew(cardContainerMultiColumnStyles.cardDivider, {
    css: css`
        border-bottom: none;
        padding: 16px;
        border: 1px solid ${themeBackgrounds.lightGray};
        background: ${themeColors.primary.white};
    `,
});

cardContainerMultiColumnStyles.gridItem = mergeToNew(cardContainerMultiColumnStyles.gridItem, {
    width: [12, 6, 6, 4, 4],
    css: css`
        position: relative;
    `,
});
